import React from 'react'

const CustomButton = ({ text, myClass, submit }) => {
  return (
    <>
      <button
        type={submit}
        className={`text-lg text-[#FCFCFC] font-semibold bg-[#241DB6] px-6 py-3 rounded-full transition-all ease-linear duration-300 hover:text-[#241DB6] hover:bg-white border border-solid border-[#241DB6] cursor-pointer max-sm:text-sm ${myClass}`}
      >
        {text}
      </button>
    </>
  );
};

export default CustomButton